import request from '../libs/request';

const res = 'CustomPage';

export default {
  get(id) {
    return request({
      url: `api/${res}/get`,
      method: 'get',
      params: {
        id
      }
    });
  }
};
